module.exports = __webpack_public_path__ + "static/media/mask-fitting.40cd0351.png";